/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Trust_Song_BodyInputs */

const en_directory_ai_tools_trust_song_body = /** @type {(inputs: Directory_Ai_Tools_Trust_Song_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lyrics, vocals and beat are made for you, so nothing gets muted.`)
};

const zh_directory_ai_tools_trust_song_body = /** @type {(inputs: Directory_Ai_Tools_Trust_Song_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`歌词、人声和 beat 都是为你生成的，不会被平台静音。`)
};

/**
* | output |
* | --- |
* | "Lyrics, vocals and beat are made for you, so nothing gets muted." |
*
* @param {Directory_Ai_Tools_Trust_Song_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_trust_song_body = /** @type {((inputs?: Directory_Ai_Tools_Trust_Song_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Trust_Song_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_trust_song_body(inputs)
	return zh_directory_ai_tools_trust_song_body(inputs)
});
export { directory_ai_tools_trust_song_body as "directory.ai_tools.trust.song_body" }